import '../../Assets/Styles/home.css';
import '../../Assets/Styles/order.css';
import '../../Assets/Styles/admin.css';
import React,{useState,useEffect} from "react";
import { useMediaQuery } from 'react-responsive'
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import {Link,useNavigate} from 'react-router-dom';

import * as config from '../../Config/api.js';

import { Button } from 'primereact/button'; 
import { Dialog } from 'primereact/dialog';
import { Divider } from 'primereact/divider';
import { addLocale } from 'primereact/api';
import { confirmDialog, ConfirmDialog } from 'primereact/confirmdialog';
import { Toast } from 'primereact/toast';
import { ProgressSpinner } from 'primereact/progressspinner';
import Grid from '@mui/material/Grid';

import Box from '@mui/material/Box';

// Load Icons
import iconDocument from '../../Assets/Images/iconDocument.svg';

// Load Actions
import * as AppActions from '../../Store/Actions/App';
import * as PartnerActions from '../../Store/Actions/Partner';

import HeaderView from '../../Components/Layout/Header';

// Load Componentes
import SideMenu from '../../Components/SideMenu';
import AlertView from '../../Components/AlertModal';
import DocumentModal from './DocumentModal';
import StatusNotification from '../../Components/StatusNotification';



import {
	maskPhone,
	formatFileSize
} from '../../Components/Utils';

const documentTypes = [
    { label: 'Contrato Social', value: 'contratoSocial' },
    { label: 'Cartão CNPJ', value: 'cartaoCNPJ' },
    { label: 'CRP do responsável', value: 'crmResponsavel' },
    { label: 'Certificados', value: 'certificado' },
    // Adicione outros tipos conforme necessário
]

const documentName = {
	contratoSocial: 'Contrato Social',
	cartaoCNPJ: 'Cartão CNPJ',
	crmResponsavel: 'CRP do Responsável',
	certificado: 'Certificados',
	default: 'Documento / Outros'
}

// export default function Reservation() {
const DocumentsView = (props) => {
	
// Set var from props
const {
	setDialog,
	dialog,
	retrieveCompanyComprobationDocuments,
	createCompanyComprobationDocument,
	deleteCompanyComprobationDocument,
	deleteCompanyComprobationDocumentFile,
	currentPartner
} = props;

// Set Overlay obj
const toast = React.useRef(null);

const isDesktopOrLaptop = useMediaQuery({
query: '(min-width: 1024px)'
})
const isTabletOrMobile = useMediaQuery({ query: '(max-width: 1023px)' })
const isSpecialDesktop = useMediaQuery({ query: '(max-width: 1500px)' })
const isMobile = useMediaQuery({ query: '(max-width: 767px)' });

const [stillConnected, setStillConnected] = React.useState(false);
const onStillConnectedChange = (e) => {
	if (e.checked)
		setStillConnected(true);
	else
		setStillConnected(false);
}  // end function
	
const [loading, setLoading] = React.useState(true); 
const [saving, setSaving] = React.useState(false); 

// Alert control
const [validateRegistry, setValidateRegistry] = React.useState(false); 
const [alert, setAlert] = React.useState(false); 
const [alertTitle, setAlertTitle] = React.useState("Informações"); 
const [alertAction, setAlertAction] = React.useState(""); 
const [alertBody, setAlertBody] = React.useState("Conteúdo dinâmico"); 

const [documents, setDocuments] = useState([]); // Lista de documentos
const [modalVisible, setModalVisible] = useState(false); // Controle da modal
  
/* -------------------------------- */ 
/* Custom methods and options START */
/* -------------------------------- */


const retrieveItemsList = () => {

  setLoading(true);
  retrieveDocuments();

}; // end retrieveItemsList	

 
/* -------------------------------- */ 
/* Custom methods and options END */
/* -------------------------------- */
 const retrieveDocuments = () => {
  retrieveCompanyComprobationDocuments({
    setSuccess: (data) => {
      setDocuments(data);
	  setLoading(false);
    },
    setError: (msg) => {
	  showErrorToast('Erro ao buscar documentos. Recarregue a página. Erro: ', msg);
	  setLoading(false);
    }
  });
};


const handleDeleteDocument = (type) => {
  deleteCompanyComprobationDocument(type, {
    setSuccess: () => {
      showSuccessToast('Documento excluído', 'Documento removido com sucesso.');
      retrieveItemsList();
    },
    setError: (msg) => {
	  showErrorToast('Erro ao excluir documento', msg);
    }
  });
};

const handleDeleteDocumentFile = (fileId) => {
  deleteCompanyComprobationDocumentFile(fileId, {
    setSuccess: () => {
      showSuccessToast('Arquivo removido', 'Arquivo excluído com sucesso.');
      retrieveItemsList();
    },
    setError: (msg) => {
      showErrorToast('Erro ao excluir arquivo', msg);
    }
  });
};

const showSuccessToast = (summary, detail) => {
  toast.current?.show({
    severity: 'success',
    summary,
    detail,
    life: 3000
  });
};

const showErrorToast = (summary, detail) => {
  toast.current?.show({
    severity: 'error',
    summary,
    detail,
    life: 4000
  });
};

/* -------------------- */ 
/* Common methods START */
/* -------------------- */

// Run after mount component
React.useEffect(() => {


  // set scroll to top
  window.scrollTo(0, 1);
  
  // Load list
  retrieveItemsList();
	  
  // Runs when UNMOUNT component
  return () => {
	
	// unmount...	
	
  };
  
}, []); // end useEffect 

// Set calendar locale
addLocale('br', {
	firstDayOfWeek: 1,
	dayNames: ['domingo', 'segunda-feira', 'terça-feira', 'quarta-feira', 'quinta-feira', 'sexta-feira', 'sábado'],
	dayNamesShort: ['dom', 'seg', 'ter', 'qua', 'qui', 'sex', 'sáb'],
	dayNamesMin: ['D', 'S', 'T', 'Q', 'Q', 'S', 'S'],
	monthNames: ['janeiro', 'fevereiro', 'março', 'abril', 'maio', 'junho', 'julho', 'agosto', 'setembro', 'outubro', 'novembro', 'dezembro'],
	monthNamesShort: ['jan', 'fev', 'mar', 'abr', 'mai', 'jun', 'jul', 'ago', 'set', 'out', 'nov', 'dez'],
	today: 'Hoje',
	clear: 'Limpar'
});

// set Use of history for PUSH 
var navigate = useNavigate(); 

/* -------------------- */ 
/* Common methods END */
/* -------------------- */
 
  return (
	<>
	<div id="adminSection" style={{marginTop:"0"}} className={isTabletOrMobile ? "login__wrapper mobile" : "login__wrapper"} >
		<div style={{height:"auto"}} className={isTabletOrMobile ? "login__wrapper_form_wrapper mobile" : "login__wrapper_form_wrapper"}> 		

			<HeaderView isOnAdmin={true} />

			<div className={isTabletOrMobile ? "login__form_wrapper mobile" : "login__form_wrapper"} style={{alignItems:"flex-start",marginTop:"6rem"}}>
						
				<div style={{flex:1,display:"flex",flexDirection:isMobile ? "column" : "row",justifyContent:"center",alignItems:"flex-start",gap:"10px",padding:isMobile ? "10px" : "40px",marginTop:"40px",height:"auto",marginLeft:"auto",marginRight:"auto",width:"100%",border:"0px solid red"}}>
				
						{/* Admin Side Menu */}
						<SideMenu state="open" />
						
						{/* Admin Content */}
						<div style={{flex:1,height:"100%",display:"flex",flexDirection:"column",alignItems:"center",justifyContent:"center"}}>
						
							<div style={{height:isMobile ? "unset" : "64px",width:"100%",display:"flex",flexDirection:isMobile ? "column" : "row",justifyContent:"center",alignItems:"center",gap:isMobile ? "1rem" : "",paddingBottom:isMobile ? "1rem" : ""}}>
							
								<div style={{textAlign:"left",flex:2,color: '#2E0249', fontFamily: 'Titillium Web', fontSize: '36px', fontStyle: 'normal', fontWeight: 400, lineHeight: '120%', letterSpacing: '3.6px',padding:"10px"}}>Documentos comprobatórios</div>
								
								<div style={{flex:1,display:"flex",flexDirection:"row",justifyContent:"end",alignItems:"center"}}>
									<Button label="Adicionar documento" className="filledButton" icon="pi pi-plus" loading={saving} onClick={() => setModalVisible(true)} style={{height:"unset"}} size="small" />
								</div>
							
							</div>
							
							
							<div style={{flex:1,width:"100%",backgroundColor:"#FFF"}}>
							
								<div className="card" style={{minHeight:"66vh",zIndex: 8,position:"relative"}}>
			
									<Box
									  sx={{
										width: isMobile ? "100%" : "80%",
										padding:"20px",
										minHeight:"50vh"
									  }}
									>
										<div className="registerModalIntro"> <i>Se precisar, você pode adicionar um ou mais documentos. <br /> Se o seu cadastro estiver aprovado, não será possível excluir um documento, apenas adicionar.</i></div>	

										<Divider />

										{loading &&
										<>
											<div className="flex-row justify-center align-items-center" style={{minHeight:"45vh",width:"100%",zIndex:"10",backgroundColor:"#FFF"}}>
												<div className="flex flex-column align-items-center">
													<ProgressSpinner style={{width:"50px",height:"50px"}} />
													<span style={{marginTop:"1rem",fontSize:"1.1rem",fontFamily:"Graphie"}}>Carregando documentos...</span>
												</div>
											</div>
										</>
										}										


									  	{!loading &&
										<>
											<Box style={{display:"flex",flexDirection:"row",alignItems:"flex-start",justifyContent:"flex-start",flexWrap:"wrap"}}>

											{/* Results from API */}
											{documents.map((item, index) => {
											const [type, files] = Object.entries(item)[0]; // extrai a chave e o array de arquivos

											return (
												<div className="documentCard" style={{ margin:isMobile ? "" : "20px",maxWidth:"450px",minWidth:isMobile ? "100%" : "450px",marginBottom:isMobile ? "1rem" : ""}} key={`${type}-${index}`}>
												<div className="documentCard_header flex-row justify-start align-items-center gap-1" color="info" icon>
													<img src={iconDocument} alt="Ícone de documento" style={{ width: "1.5rem", height: "auto" }} />
													<h4 style={{ color: "#4D4792" }}>{documentName[type != 'desconhecido' ? type : 'default']}</h4>

													<div style={{ textAlign: "right", flex: 1, display: "flex", justifyContent: "flex-end" }}>
													<Button
														size="small"
														icon="pi pi-times"
														className="textButton"
														style={{ alignSelf: "flex-end", height: "unset" }}
														onClick={() => {
														confirmDialog({
															message: 'Deseja realmente excluir este documento?',
															header: 'Confirmar Exclusão',
															icon: 'pi pi-exclamation-triangle',
															acceptLabel: 'Sim',
															rejectLabel: 'Cancelar',
															acceptClassName: 'filledButton',
															rejectClassName: 'textButton',
															accept: () => handleDeleteDocument(type)
														});
														}}
													/>
													</div>
												</div>

												<div className="w100 documentCard_body flex-column justify-start align-items-start gap-05">
													{files.map((file) => {
													const url = config.API_URL+`/media/company/retrieve/comprobationDocument/${file.fileHash || file.fileName}`;

													return (
														<div key={file.id} className="flex-1 flex-row justify-start align-items-center" style={{ gap: "0.5rem", marginTop: "0.5rem" }}>
														<div className="flex-1 documentCard_body__label">
															<i>{file.name}</i> <small>({formatFileSize(file.fileSize)})</small>
														</div>

														<Button size="small" className="textButton">
															<a
															className="button"
															href={url}
															style={{ color: "#C53F84", fontSize: "0.9rem", textDecoration: "none" }}
															target="_blank"
															rel="noopener noreferrer"
															>
															Download
															</a>
														</Button>

														<Button
															size="small"
															label="Excluir"
															className="textButton"
															style={{ color: "#C53F84", fontSize: "0.9rem" }}
															onClick={() => {
															confirmDialog({
																message: 'Deseja excluir este arquivo?',
																header: 'Excluir Arquivo',
																icon: 'pi pi-exclamation-triangle',
																acceptLabel: 'Sim',
																rejectLabel: 'Cancelar',
																acceptClassName: 'filledButton',
																rejectClassName: 'textButton',
																accept: () => handleDeleteDocumentFile(file.id)
															});
															}}
														/>
														</div>
													);
													})}
												</div>
												</div>
											);
											})}

												
												{ documents.length === 0 && 
												<>
													<StatusNotification status="warn" summary="Atenção" message={<>Você não tem <b>Documentos comprobatórios</b> cadastrados. Adicione os documentos da sua empresa para evitar bloqueio do cadastro.</>} />
													<div className="documentCard_noDocument" style={{padding:"2rem",fontSize:"2rem"}}> Nenhum documento encontrado... </div>
												</>						
												}

											</Box>		
										</>
										}			

										<Grid container spacing={1} style={{marginTop:"20px"}}>
											<Grid item xs={12} sm={12}>
												<div className="w100 tAlignL documentsGuideContainer">

												Documentos necessários para aprovação do cadastro:
												<ul>
												<li>Contrato Social</li>
												<li>Cartão CNPJ</li>
												<li>CRP do responsável (apenas para clínicas)</li>
												<li>Certificados de conclusão de curso, especialização, pós-graduação, mestrado e etc (OPCIONAL - apenas para clínicas)</li>
												</ul>

												</div>
											</Grid> 																						  
										</Grid> 
										  
									{!loading &&
									<>
										<div className="modalFooterButtons" style={{marginTop:"20px",textAlign:"left"}}>

											<div className="modalFooterButtonsRight">
												<Button label="Adicionar documento" className="filledButton" icon="pi pi-plus" loading={saving} onClick={() => setModalVisible(true)}  />
											</div>
											
										</div>
									</>
									}			

								<DocumentModal
								visible={modalVisible}
								onHide={() => setModalVisible(false)}
								documentTypes={documentTypes}
								onSubmit={createCompanyComprobationDocument} // ✅ agora passa corretamente a função
								setAlert={setAlert}
								setAlertTitle={setAlertTitle}
								setAlertBody={setAlertBody}
								showSuccessToast={showSuccessToast}
								showErrorToast={showErrorToast}
								retrieveItemsList={retrieveItemsList}
								onSuccess={() => {
									setModalVisible(false);
									retrieveDocuments();
								}}
								/>																
						
								<AlertView
									alert={alert}
									setAlert={setAlert}
									alertTitle={alertTitle}
									alertBody={alertBody}
									alertAction={alertAction}
									scrollBlock={true}				
								/>
								</Box>
								
									
								</div>							
							
							</div>
						
						</div>
						
				</div>
			
			</div> 
		</div>
		
				
	</div>
	<ConfirmDialog />
	<Toast ref={toast} position="bottom-center" />
	</>
  );
	
}

const mapStateToProps = store => ({
  dialog:store.appReducer.dialog,
  masterUser:store.appReducer.masterUser,
  currentPartner:store.appReducer.currentPartner,
 });
const mapDispatchToProps = dispatch => bindActionCreators({ ...AppActions, ...PartnerActions }, dispatch);

export default connect(
		mapStateToProps,
		mapDispatchToProps
	)(DocumentsView);	


